import { get } from 'lodash';
import { plural } from '@cian/utils';

import app from '../../../scripts/app';
import template from './video.jade';

// TODO надо использовать нормальный ангуляровский валидатор основанный на ng-model, а не кастомные флаги для ошибок
app.component('cianVideo', {
  template,
  bindings: {
    ad: '=',
  },
  controller: [
    '$rootScope', '$http', '$uibModal', 'addFormConfig', 'popupService', 'deviceService',
    function ($rootScope, $http, $uibModal, addFormConfig, popupService, deviceService) {
      this.isMobile = deviceService.isMobile;
      this.clearError = () => {
        this.form.youtube.$setValidity('youtubeVideo', true);
        this.errorText = null;
        this.violationText = null;
      };

      this.isLoading = false;
      this.ad.videos = this.ad.videos || [];
      this.errorText = null;
      this.violationText = null;

      $rootScope.$on('video.hasModerationViolation', () => {
        this.violationText = 'Видео не отображается на сайте, так как содержит нарушения.';
      });

      $rootScope.$on('youtube.invalid', (event, data) => {
        const { code, maxLength } = data;

        this.form.youtube.$setValidity('youtubeVideo', false);

        if (code === 'videoIsTooLong') {
          const lengthInMunutes = maxLength / 60;
          const lengthInMunutesPluralized = plural(lengthInMunutes, ['минута', 'минуты', 'минут']);

          this.errorText = `Максимальная длина видео — ${lengthInMunutes} ${lengthInMunutesPluralized}`;
        }

        this.youtubeLink = this.youtubeLink || get(this.ad, 'videos[0].url', '');
        this.ad.videos = [];
      });

      this.parseVideoId = (url = '') => {
        // Взято тут https://gist.github.com/takien/4077195
        let ID = '';
        url = url.replace(/(>|<)/gi, '').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
        if (url[2] !== undefined) {
          ID = url[2].split(/[^0-9a-z_\-]/i);
          ID = ID[0];
        } else {
          ID = url;
        }
        return ID;
      };

      this.showPopup = () => {
        const isMobile = deviceService.isMobile;
        const popupParams = {
          animation: true,
          windowTopClass: 'youtube-modal',
          template: `<img src="/static/images/youtube_url.gif">`,
        };
        const modalInstance = isMobile
          ? $uibModal.open({
              ...popupParams,
              appendTo: $(document).find('.modal-wrapper'),
              openedClass: 'modal-open',
            })
          : $uibModal.open({
              ...popupParams,
            });

        if (isMobile) {
          $(document).find('.modal-wrapper').addClass('modal-open');
          $(document).find('body').addClass('modal-body-wrapper');
        }

        modalInstance.closed.finally(() => {
          if (isMobile) {
            $(document).find('.modal-wrapper').removeClass('modal-open');
            $(document).find('body').removeClass('modal-body-wrapper');
          }
        });
      };

      this.removeVideo = () => {
        this.clearError();
        this.youtubeLink = '';
        this.ad.videos = [];
      };

      this.getPreview = url => {
        return `https://i1.ytimg.com/vi/${this.parseVideoId(url)}/0.jpg`;
      };

      this.checkYoutubeLink = () => {
        this.isLoading = true;
        this.clearError();
        $http.get('/addform/v2/validate-video/', {
          params: {
            url: this.youtubeLink,
            offerId: this.ad.id,
          }
        })
          .then(res => {
            this.isLoading = false;
            if (res.data && res.data.data.code === 'ok') {
              this.ad.videos = [{
                url: this.youtubeLink
              }];
            } else if (res.data && res.data.data.code === 'hasModerationViolation') {
              this.ad.videos = [{ url: this.youtubeLink }];
              $rootScope.$emit('video.hasModerationViolation');
            } else {
              $rootScope.$emit('youtube.invalid', res.data.data);
            }
          })
          .catch(err => {
            this.isLoading = false;
            popupService.openPopup('serverError');
          });
      };

      // TODO сделать нормальный валидатор, использовать возможности ng-model
      this.$onDestroy = () => {
        this.clearError();
      };
    }]
});
